import React from 'react';
import '../src/assets/fonts/fontawesome-free-6.2.1-web/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import IdentityServerApp from './IdentityServerApp';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { OidcProvider } from "@axa-fr/react-oidc";
import Home from "./components/home/home";
import { useIdentityServer, getIdentityServerConfiguration, normalizeUrl } from './services/authorizationService';
import { SessionLost } from './components/shared/SessionLost';
import { Loader } from './components/shared/Loader';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

if (useIdentityServer) {
    let oidcConfiguration = getIdentityServerConfiguration();

    // This window.fetch override is a temporary hack to handle authorization flow with PKE
    // It is required because our current identity server 3 doesn't support PKE without a secret
    // This is still secure even if the secret is exposed due to how auth flow with PKE works
    const { fetch: originalFetch } = window;
    window.fetch = async (...args) => {
        let [resource, config] = args;

        if (resource.includes('/connect/token') || resource.includes('/connect/revocation')) {
            config.body += `&client_secret=${oidcConfiguration.client_secret}`;
        }
        
        const response = await originalFetch(resource, config);
        return response;
    };

    // Normalize both sides before comparing so that a stray double slash in
    // either value (e.g. https://host//identity from a build pipeline injection)
    // does not cause a false-negative and render the wrong application branch.
    if (normalizeUrl(window.location.href.toLowerCase()).includes(normalizeUrl(oidcConfiguration.authority))) {
        root.render(
            <BrowserRouter>
                <OidcProvider configuration={oidcConfiguration}
                    loadingComponent={Loader}
                    authenticatingComponent={Loader}
                    callbackSuccessComponent={Loader}>
                    <Routes>
                        <Route path="*" element={<Home />} />
                    </Routes>
                </OidcProvider>
            </BrowserRouter>);
    } else {
        root.render(
            <BrowserRouter basename={baseUrl}>
                <OidcProvider configuration={oidcConfiguration}
                    authenticatingErrorComponent={SessionLost}
                    sessionLostComponent={SessionLost}
                    authenticatingComponent={Loader}
                    callbackSuccessComponent={Loader}
                    loadingComponent={Loader}>
                    <IdentityServerApp />
                </OidcProvider>
            </BrowserRouter>);
    }
}
else {
    root.render(
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();